const ths = [
  {
    id: 1,
    label: 'Activity type',
    intlKey: 'table.activity_type',
    sortable: false,
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Activity',
    intlKey: 'table.activity',
    sortable: false,
    sortableId: 'person.firstName'
  },
  {
    id: 3,
    label: 'Goal',
    intlKey: 'table.goal',
    sortable: false
  },
  {
    id: 4,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false,
    right: true
  }
]

export default ths
